/* old navbar
// Enable tooltips everywhere
$(function () {
    $('[data-toggle="tooltip"]').tooltip()
})

//Navbar 2
$(document).ready(function () {
    $('.navbar-light .dmenu').hover(function () {
        $(this).find('.sm-menu').first().stop(true, true).slideDown(150);
    }, function () {
        $(this).find('.sm-menu').first().stop(true, true).slideUp(105)
    });
});

$(document).ready(function () {
    $('.navbar .dmenu').hover(function () {
        $(this).find('.sm-menu').first().stop(true, true).slideDown(150);
    }, function () {
        $(this).find('.sm-menu').first().stop(true, true).slideUp(105)
    });
});

$(document).ready(function(){
	var altura = $('.menu').offset().top;

	$(window).on('scroll', function(){
		if ( $(window).scrollTop() > altura ){
			$('.menu').addClass('menu-fixed');
		} else {
			$('.menu').removeClass('menu-fixed');
		}
	});

});
*/

/* Base navbar */
$("#menu-btn").click(function () {
    var x = document.getElementById("myTopnav");
    if (x.className === "topnav") {
        x.className += " responsive";
    }
    else {
        x.className = "topnav";
    }
});

// For fix navbar with scroll page
// $(document).ready(function () {
//     var altura = $('.menu').offset().top;

//     $(window).on('scroll', function () {
//         if ($(window).scrollTop() > altura) {
//             $('.menu').addClass('menu-fixed');
//         } else {
//             $('.menu').removeClass('menu-fixed');
//         }
//     });

// });

// Go up button
$(document).ready(function () {

    $('.ir-arriba').click(function () {
        $('body, html').animate({
            scrollTop: '0px'
        }, 300);
    });

    $(window).scroll(function () {
        if ($(this).scrollTop() > 0) {
            $('.ir-arriba').slideDown(300);
        } else {
            $('.ir-arriba').slideUp(300);
        }
    });

});
